import { Type } from 'class-transformer';
import { IsNumber, IsOptional, IsString, Max, Min } from 'class-validator';

export const ATTRACTION_MAP_LIMIT = 500;

export type AttractionMapBounds = {
    west: number;
    south: number;
    east: number;
    north: number;
};

export class AttractionMapQueryDto implements AttractionMapBounds {
    @Type(() => Number)
    @IsNumber()
    @Min(-180)
    @Max(180)
    west: number;

    @Type(() => Number)
    @IsNumber()
    @Min(-180)
    @Max(180)
    east: number;

    @Type(() => Number)
    @IsNumber()
    @Min(-90)
    @Max(90)
    south: number;

    @Type(() => Number)
    @IsNumber()
    @Min(-90)
    @Max(90)
    north: number;

    @IsOptional()
    @IsString()
    searchText?: string;

    @IsOptional()
    where?: Record<string, unknown>;
}

export type AttractionMapPoint = {
    id: number;
    title: string;
    lat: number;
    lng: number;
};

export type AttractionMapRO = {
    items: AttractionMapPoint[];
    limitReached: boolean;
};
